import React from 'react'
import { ReactComponent as Error } from "../../../assets/icon/error.svg"

import { Container, Span } from './styles'

export function InputSpan({ text }) {
  return (
    <Container display={!!text}>
      <Error size={16} />
      <Span>{text || 'Error'}</Span>
    </Container>
  )
}
